import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { CommonService } from '@app/shared/services/common.service';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { QUEUE_CONSTANTS } from '@app/shared/constants/queue.constants';
import { take } from 'rxjs';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { educatorCommunicationUploadWithClientBlobPut } from '../../educator-blob-upload.util';
import { SupportingDocumentRuleConfigService } from '@app/pages/page-designer/supporting-document-rule-config/supporting-document-rule-config.service';
import { SupportingDocumentGridOption } from '@app/pages/page-designer/supporting-document-grid/supporting-document-grid-config.model';
import {
  appendProfileUploadToDashboardRow,
  buildProfileUploadRowForLocalCache,
  toDuplicateLookupOptions
} from '../../educator-duplicate-document.util';
import { EducatorDocumentPreviewModalService } from '../../educator-document-preview-modal.service';
import { resolveEducatorDocumentFileUrl } from '../../educator-document-download.util';
import { AlertService } from '@app/@core/services/alert.service';
import { StaffDocumentUploadNoticeModalService } from '@app/shared/services/staff-document-upload-notice-modal.service';
import { getCancelFileUploadModalConfig } from '@app/shared/constants/cancel-file-upload-modal.util';
import { EducatorDuplicateDocumentGuardService } from '@app/shared/services/educator-duplicate-document-guard.service';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import * as FileSaver from 'file-saver';
import { select } from '@ngrx/store';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { flipLookupUploadDropdownAbove } from '../../lookup-upload-dropdown.util';
import { TooltipModule } from 'primeng/tooltip';
import { ModalConfig } from '@app/shared/constants/modal.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LOOKUP_USER_SECTION_FORM_IDS } from '@app/lookup-user-detail/lookup-user-form-ids.constants';
import { resolveProfileTabSectionFromLookupCategory } from '@app/lookup-user-detail/educator-profile-document-labels.util';

interface CommunicationRow {
  [key: string]: unknown;
}

interface NoteTypeOption {
  key: number;
  value: string;
}

@Component({
  selector: 'lookup-user-communication-tab',
  standalone: true,
  imports: [CommonModule, DataGridComponent, MaterialUIModule, ReactiveFormsModule, DropdownModule, TooltipModule, FormsModule],
  templateUrl: './lookup-user-communication-tab.component.html',
  styleUrls: ['./lookup-user-communication-tab.component.scss']
})
export class LookupUserCommunicationTabComponent implements OnInit, OnChanges {
  @Input() communicationsData: unknown;
  @Input() educatorDashboardRow: Record<string, unknown> | null = null;
  @Input() personId: string | null = null;
  @Input() applicationId: string | null = null;
  
  @ViewChild('uploadModel') uploadModel!: TemplateRef<any>;
  @ViewChild('viewEmailModal') viewEmailModal!: TemplateRef<any>;
  @ViewChild('resendEmailModal') resendEmailModal!: TemplateRef<any>;
  @ViewChild('editNoteModal') editNoteModal: any;

  user:any|null = null
  notesSectionExpanded = false;
  emailLogSectionExpanded = false;
  showAddNoteForm = false;
  showDatePickerInput = false;
  private viewEmailModalRef: NgbModalRef | null = null;
  selectedEmailLog: CommunicationRow | null = null;
  currentDate: string = new Date().toISOString().split('T')[0];
  sanitizedEmailBody: SafeHtml | null = null;
  


  addNoteForm: FormGroup;
  noteTypeOptions: NoteTypeOption[] = [];
  private readonly defaultNoteTypeOptions: NoteTypeOption[] = [
    { key: 1, value: 'Call' },
    { key: 2, value: 'Correspondance' },
    { key: 3, value: 'Email' },
    { key: 4, value: 'Walk-In' },
    { key: 5, value: 'Other' }
  ];

  uploadData: any = {
    file: null,
    fileName: '',
    type: ''
  };
  selectedUploadMeta: { fileName: string; contentType: string; file?: File | null;  type?: string; category?: string,  document_type_description?: string;  } = {
    fileName: '',
    contentType: '',
    file: null,
    type: '',
    category: '',
     document_type_description: ''   
  };

  errorMessage: Record<string, string> = {};

  uploadError: string | null = null;
  saveEnable = true;
  private uploadModalRef: NgbModalRef | null = null;
  // private viewEmailModalRef: NgbModalRef | null = null;
  private resendEmailModalRef: NgbModalRef | null = null;
private pendingResendRow: CommunicationRow | null = null;
  showNotesColumnChooser = false;
  showEmailColumnChooser = false;
  lastValidValue = '';

  notesHeaders: any[] = [];

  emailLogHeaders: any[] = [];

  allNotesColumns: { key: string; label: string }[] = [];
  allEmailColumns: { key: string; label: string }[] = [];

  visibleNotesColumns: { [key: string]: boolean } = {};
  visibleEmailColumns: { [key: string]: boolean } = {};

  notesRows: CommunicationRow[] = [];
  emailRows: CommunicationRow[] = [];
  private emailLogsLoadedFromApi = false;
  private emailLogsLoadingPersonId: string | null = null;
  private emailLogsPersonId: string | null = null;

  notesGridData: DataGridVO = new DataGridVO();
  emailGridData: DataGridVO = new DataGridVO();
  @Output() refreshed = new EventEmitter<any>();
  uploadDocMetaForm: FormGroup;
  
  /** All upload categories from the platform supporting-doc lookup (System A). */
  categoryOptions: SupportingDocumentGridOption[] = [];
  /** Type options for the selected upload category (System A). */
  filteredDocumentTypeOptions: SupportingDocumentGridOption[] = [];
  lookupToast : any = [];
  @ViewChild('viewNoteDetailModal') viewNoteDetailModal: any;
  selectedViewNote: CommunicationRow | null = null;
  private viewNoteDetailModalRef: NgbModalRef | null = null;
  viewNoteTypeKey: number | null = null;
  viewDocumentCategoryId: string | null = null;
  viewDocumentTypeId: string | null = null;
  viewDocumentTypeOptions: SupportingDocumentGridOption[] = [];
  editNoteForm!: FormGroup;
  selectedNote: any = null;
  editNoteIndex: number = -1;
  editNoteModalRef: any = null;
  isEditNoteUpload = false;
  // currentUploadSection: 'academic-Background' | 'employment_prof_dev' | 'Additional_prof_dev' | 'programs-upload' = 'academic-Background';
  currentUploadSection:
    | 'name-history'
    | 'identity-contact'
    | 'veteran-status'
    | 'nevada-testing'
    | 'out-of-state-testing'
    | 'history-disclosure'
    | 'academic-Background'
    | 'employment_prof_dev'
    | 'verifiable-teaching'
    | 'verifiable-business'
    | 'Additional_prof_dev'
    | 'out-of-state-licensure'
    | 'programs-upload' = 'academic-Background';

  constructor(private commonService: CommonService,
     private cd: ChangeDetectorRef,
     private fb: FormBuilder,
    private modalService: NgbModal,
    private staffDocNoticeModal: StaffDocumentUploadNoticeModalService,
    private duplicateDocGuard: EducatorDuplicateDocumentGuardService,
    private httpService: HttpService,
    private alertService: AlertService,
    private documentPreviewModal: EducatorDocumentPreviewModalService,
    private sanitizer: DomSanitizer,
    private supportingDocLookupService: SupportingDocumentRuleConfigService
    ) {
      this.errorMessage = JSON.parse(window.localStorage.getItem('errorMessage') || '{}');
      this.addNoteForm = this.fb.group({
      date: new FormControl(new Date().toLocaleDateString('en-US'), [Validators.required,this.validateDate]),
      noteType: new FormControl('', Validators.required),
      notes: new FormControl('', [Validators.required,this.maxWordsValidator(100)]),
      supportingDocument: new FormControl('')
    });
    this.uploadDocMetaForm = this.fb.group({
      category: ['', Validators.required],
      type: ['', Validators.required]
    });
    this.initializeColumns();
    this.updateDataGridConfig();

    this.editNoteForm = this.fb.group({
  date:              [''],
  noteType:          [null, Validators.required],
  supportingDocument:['', Validators.required],
  notes:             ['', Validators.required]
});
    }
    

onInput() {
  const ctrl = this.addNoteForm.get('notes');
  const text = ctrl?.value || '';

  const words = text.trim().split(/\s+/).filter(Boolean);

  if (words.length > 100) {
    // 🔴 Reject input beyond 100 words
    ctrl?.setValue(this.lastValidValue, { emitEvent: false });
  } else {
    // ✅ Store last valid value
    this.lastValidValue = text;
  }
}




  ngOnInit(): void {
    this.user = sessionStorage.getItem('user')
    this.loadNoteTypeOptions();
    this.loadDocCategoryOptions();
    this.commonService.getMetaData(QUEUE_CONSTANTS.USER_COMMUNICATION)
      .pipe(take(1))
      .subscribe((response: any) => {
        this.notesHeaders = Array.isArray(response?.notesGrid) ? response.notesGrid : [];
        this.emailLogHeaders = Array.isArray(response?.emailLogGrid) ? response.emailLogGrid : [];

        this.allNotesColumns = this.notesHeaders.map(header => ({ key: header.dataField, label: header.caption || header.dataField }));
        this.allEmailColumns = this.emailLogHeaders.map(header => ({ key: header.dataField, label: header.caption || header.dataField }));

        this.allNotesColumns.forEach(column => {
          if (typeof this.visibleNotesColumns[column.key] === 'undefined') {
            this.visibleNotesColumns[column.key] = true;
          }
        });

        this.allEmailColumns.forEach(column => {
          if (typeof this.visibleEmailColumns[column.key] === 'undefined') {
            this.visibleEmailColumns[column.key] = true;
          }
        });

        this.updateDataGridConfig();
      });
      this.updateDataGridConfig();
       this.loadToastMessages();
       this.loadEmailLogs();
  }

  private loadNoteTypeOptions(): void {
    this.httpService.get(`${API_ENDPOINTS.DOMAIN_LOOKUP_BY_TYPE}Profile_Note_Type`)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          const options = Array.isArray(response?.data)
            ? response.data
                .map((item: any) => ({
                  key: Number(item?.key),
                  value: String(item?.value || '').trim()
                }))
                .filter((item: NoteTypeOption) => Number.isFinite(item.key) && item.value.length > 0)
            : [];

          this.noteTypeOptions = options.length > 0 ? options : [...this.defaultNoteTypeOptions];
        },
        error: () => {
          this.noteTypeOptions = [...this.defaultNoteTypeOptions];
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['personId'] && !changes['personId'].firstChange) {
      this.emailLogsLoadedFromApi = false;
      this.emailLogsPersonId = null;
    }

    this.mapCommunicationData();
    this.updateDataGridConfig();

    if (changes['personId']) {
      this.loadEmailLogs();
    }
  }
  
  maxWordsValidator(maxWords: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const words = control.value.trim().split(/\s+/);
    return words.length > maxWords ? { maxWords: { requiredWords: maxWords, actualWords: words.length } } : null;
  }
}

  toggleNotesSection(): void {
    this.notesSectionExpanded = !this.notesSectionExpanded;
  }

  toggleEmailSection(): void {
    this.emailLogSectionExpanded = !this.emailLogSectionExpanded;
  }

  closeNotesColumnChooser(): void {
    this.showNotesColumnChooser = false;
    this.updateDataGridConfig();
  }

  closeEmailColumnChooser(): void {
    this.showEmailColumnChooser = false;
    this.updateDataGridConfig();
  }

  onNotesColumnClick(key: string): void {
    this.visibleNotesColumns[key] = !this.visibleNotesColumns[key];
    this.updateDataGridConfig();
    this.cd.detectChanges();
  }

  onEmailColumnClick(key: string): void {
    this.visibleEmailColumns[key] = !this.visibleEmailColumns[key];
    this.updateDataGridConfig();
    this.cd.detectChanges();
  }

 onAddNote(): void {
    this.showAddNoteForm = true;
  }

  onCancelAddNote(): void {
    this.showAddNoteForm = false;
    this.resetAddNoteForm();
  }

  onOpenUploadWarning(): void {
    this.staffDocNoticeModal.open({ contentVariant: 'communication' }).then((confirmed) => {
      if (confirmed) {
        this.openUploadModal();
      }
    });
  }

  openUploadModal(): void {
    this.uploadData = { file: null, fileName: '', type: '' };
    this.uploadError = null;
    this.saveEnable = true;
    this.currentUploadSection = 'academic-Background';
    this.uploadModalRef = this.modalService.open(this.uploadModel, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  closeUploadPopup(): void {
    this.uploadModalRef?.close();
    this.uploadModalRef = null;
    this.uploadData = { file: null, fileName: '', type: '' };
    this.uploadError = null;
    this.saveEnable = true;
    this.currentUploadSection = 'academic-Background';
     this.uploadDocMetaForm.reset();
  }

  clearFileInput(event: any): void {
    event.target.value = null;
  }

  onDropFile(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];

    if (!allowedTypes.includes(file.type)) {
      this.uploadError = 'The selected file type is not supported';
      return;
    }
      this.setUploadedFile(file);
    }
  }

  handleFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }
    const file = input.files[0];

      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];

  if (!allowedTypes.includes(file.type)) {
    this.uploadError = 'The selected file type is not supported';
    return;
  }
    this.setUploadedFile(file);
  }

  onUploadTypeDropdownShow(dropdown: Dropdown): void {
    flipLookupUploadDropdownAbove(dropdown);
  }

  onSaveUploadFile(): void {
    if (!this.uploadData?.fileName) {
     this.alertService.error(this.lookupToast?.['T0017']);
      this.uploadError = 'Please select a file.';
      return;
    }
      if (this.uploadDocMetaForm.invalid) {
    this.uploadDocMetaForm.markAllAsTouched();
     this.alertService.error(this.lookupToast?.['T0017']);
    // this.alertService.error(this.lookupToast?.['T0017']);
    return;
  }
      const selectedTypeKey = this.uploadDocMetaForm.get('type')?.value || '';
    const selectedTypeOption = this.filteredDocumentTypeOptions.find(opt => opt.key === selectedTypeKey);
    const selectedTypeDescription = selectedTypeOption?.value || '';
     this.selectedUploadMeta = {
      fileName: this.uploadData.fileName || '',
      contentType: this.uploadData.type || '',
      file: this.uploadData.file instanceof File ? this.uploadData.file : null,
      type: this.uploadDocMetaForm.get('type')?.value || '',       // ← fix
      category: this.uploadDocMetaForm.get('category')?.value || '',
      document_type_description: selectedTypeDescription 
    };
    this.addNoteForm.get('supportingDocument')?.setValue(this.uploadData.fileName);
    this.addNoteForm.get('supportingDocument')?.markAsTouched();
  //     if (this.isEditNoteUpload) {
  //   this.editNoteForm.get('supportingDocument')?.setValue(this.uploadData.fileName);
  //   this.editNoteForm.get('supportingDocument')?.markAsTouched();
  //   this.editNoteForm.get('supportingDocument')?.markAsDirty();
  // } else {
  //   this.addNoteForm.get('supportingDocument')?.setValue(this.uploadData.fileName);
  //   this.addNoteForm.get('supportingDocument')?.markAsTouched();
  // }
  this.isEditNoteUpload = false;
    this.closeUploadPopup();
  }

  private getCurrentUserId(): number | null {
    try {
      const userRaw = sessionStorage.getItem('user');
      if (!userRaw) return null;
      const user = JSON.parse(userRaw);
      const id = user?.user_id ?? user?.id ?? user?.userId ?? null;
      return id !== null ? Number(id) : null;
    } catch {
      return null;
    }
  }

  async onSaveAddNote(): Promise<void> {
    if (this.addNoteForm.invalid) {
      this.addNoteForm.markAllAsTouched();
      return;
    }

    const formValue = this.addNoteForm.value;
    const selectedNoteType = this.noteTypeOptions.find(option => String(option.key) === String(formValue.noteType));
    const row: CommunicationRow = {
      type: selectedNoteType?.value || '-',
      notes: formValue.notes || '-',
      document_type: 'Supporting Document',
      document_name: formValue.supportingDocument || '-',
      updated_date: this.formatDisplayDate(formValue.date),
      updated_by: this.getCurrentUserName(),
      actions: ''
    };

    const formIdLabelMap: Record<string, string> = {
  'name-history': 'Name History',
  'identity-contact': 'Identity and Contact Information',
  'veteran-status': 'Veteran Status',
  'nevada-testing': 'Nevada Praxis Testing',
  'out-of-state-testing': 'Other Testing',
  'history-disclosure': 'History Disclosure',
  'academic-Background': 'Academic Background',
  'employment_prof_dev': 'District / Charter Employment',
  'verifiable-teaching': 'Verifiable Teaching Experience',
  'verifiable-business': 'Verifiable Business and Industry Work Experience',
  'Additional_prof_dev': 'Additional Professional Development',
  'out-of-state-licensure': 'Out of State or Country Licensure'
};
    const profileTabSection = this.resolveUploadProfileTabSection(formIdLabelMap);

    // Nevada/OOS (and similar activity-sourced) types: persist display label like Activities, not lookup key
    const usesGridStringType =
      this.currentUploadSection === 'nevada-testing' ||
      this.currentUploadSection === 'out-of-state-testing' ||
      this.currentUploadSection === 'out-of-state-licensure' ||
      this.currentUploadSection === 'academic-Background' ||
      this.currentUploadSection === 'employment_prof_dev' ||
      this.currentUploadSection === 'verifiable-teaching' ||
      this.currentUploadSection === 'verifiable-business' ||
      this.currentUploadSection === 'Additional_prof_dev';
    const typeKeyRaw = String(this.selectedUploadMeta.type || '').trim();
    const typeDescription = String(this.selectedUploadMeta.document_type_description || '').trim();
    const persistedDocumentType =
      usesGridStringType && typeDescription ? typeDescription : typeKeyRaw;

    if (!LOOKUP_USER_SECTION_FORM_IDS[profileTabSection]) {
      console.warn('⚠️ CRITICAL: profileTabSection NOT FOUND in LOOKUP_USER_SECTION_FORM_IDS', {
        'Looking for': profileTabSection,
        'Available keys': Object.keys(LOOKUP_USER_SECTION_FORM_IDS),
        'Close matches': Object.keys(LOOKUP_USER_SECTION_FORM_IDS).filter(k => 
          k.toLowerCase().includes(profileTabSection.toLowerCase().substring(0, 5))
        )
      });
    }
    const uploadData = {
      person_id: this.personId ? Number(this.personId) : null,
      note_type: formValue.noteType ? Number(formValue.noteType) : null,
      note: formValue.notes,
      uploaded_by: this.getCurrentUserId(),
      uploaded_at: new Date().toISOString(),
      profile_tab_section: profileTabSection,
      file_name: this.selectedUploadMeta.fileName || formValue.supportingDocument || '',
      document_category: this.selectedUploadMeta.category || '',
      document_type: persistedDocumentType,
      document_type_description: typeDescription,
      formid: LOOKUP_USER_SECTION_FORM_IDS[profileTabSection] ?? null,
      form_data: {
        ...FormData,
        cd_document_category: this.selectedUploadMeta.category || '',
        cd_document_type: persistedDocumentType
      }
    };

    const attachedFile = this.selectedUploadMeta.file instanceof File ? this.selectedUploadMeta.file : null;
    const categoryKey = String(this.selectedUploadMeta.category ?? uploadData.document_category ?? '').trim();
    const typeKey = persistedDocumentType;

    if (attachedFile != null) {
      const personIdNum = this.personId ? Number(this.personId) : 0;
      const categoryLookups = toDuplicateLookupOptions(
        categoryKey
          ? [{ key: categoryKey, value: String(uploadData.document_category ?? categoryKey) }]
          : []
      );
      const typeLookups = toDuplicateLookupOptions(
        typeKey
          ? [{ key: typeKeyRaw || typeKey, value: typeKey }]
          : []
      );
      if (personIdNum && categoryKey) {
        const proceed = await this.duplicateDocGuard.ensureProceedOrCancel({
          educatorDashboardRow: this.educatorDashboardRow,
          categoryKey,
          typeKey: typeKey || undefined,
          fileName: attachedFile.name,
          screenName: 'Lookup User - Communication',
          personId: personIdNum,
          categoryDisplay: String(uploadData.document_category ?? ''),
          typeDisplay: typeKey,
          categoryLookups,
          typeLookups
        });
        if (!proceed) {
          this.selectedUploadMeta = { fileName: '', contentType: '', file: null, type: '', category: '' };
          this.uploadData = { file: null, fileName: '', type: '' };
          this.addNoteForm.patchValue({ supportingDocument: '' });
          return;
        }
      }
    }

    const save$ =
      attachedFile != null
        ? educatorCommunicationUploadWithClientBlobPut(this.httpService, attachedFile, uploadData)
        : this.httpService.post(API_ENDPOINTS.Profile_Notes_Upload, {
            request: {
              fileName: this.selectedUploadMeta.fileName || formValue.supportingDocument || '',
              contentType: this.selectedUploadMeta.contentType || 'application/octet-stream'
            },
            uploadData,
            signedUrlRequest: {
              fileName: this.selectedUploadMeta.fileName || formValue.supportingDocument || '',
              contentType: this.selectedUploadMeta.contentType || 'application/octet-stream'
            }
          });

    save$.pipe(take(1)).subscribe({
      next: () => {
        if (attachedFile != null && categoryKey) {
          appendProfileUploadToDashboardRow(
            this.educatorDashboardRow,
            buildProfileUploadRowForLocalCache({
              cd_document_category: categoryKey,
              cd_document_type: typeKey || undefined,
              document_category: String(uploadData.document_category ?? categoryKey),
              document_type: typeKey,
              file_name: attachedFile.name,
              profile_tab_section: profileTabSection
            })
          );
        }
        this.showAddNoteForm = false;
        this.resetAddNoteForm();
        this.refreshCommunicationsData();
        this.alertService.success('Saved successfully.');
      },
      error: () => {
        this.notesRows = [row, ...this.notesRows];
        this.updateDataGridConfig();
        this.showAddNoteForm = false;
        this.resetAddNoteForm();
        this.alertService.error('Failed to save note. Please try again.');
      }
    });
  }

  downloadNotesExcel(): void {
    const visibleCols = this.allNotesColumns.filter(column => this.visibleNotesColumns[column.key]);
    if (visibleCols.length === 0) {
      window.alert('No columns selected for export');
      return;
    }

    const rows = Array.isArray(this.notesRows) ? this.notesRows : [];
    if (rows.length === 0) {
      window.alert('No data to export');
      return;
    }

    const exportRows = rows.map(row => {
      const filtered: any = {};
      visibleCols.forEach(column => {
        filtered[column.key] = row[column.key];
      });
      return filtered;
    });

    this.commonService.exportToExcel(
      exportRows,
      visibleCols.map(column => ({ label: column.label, key: column.key })),
      'CommunicationNotes.xlsx'
    );
  }

  downloadEmailExcel(): void {
    const visibleCols = this.allEmailColumns.filter(column => this.visibleEmailColumns[column.key]);
    if (visibleCols.length === 0) {
      window.alert('No columns selected for export');
      return;
    }

    const rows = Array.isArray(this.emailRows) ? this.emailRows : [];
    if (rows.length === 0) {
      window.alert('No data to export');
      return;
    }

    const exportRows = rows.map(row => {
      const filtered: any = {};
      visibleCols.forEach(column => {
        filtered[column.key] = row[column.key];
      });
      return filtered;
    });

    this.commonService.exportToExcel(
      exportRows,
      visibleCols.map(column => ({ label: column.label, key: column.key })),
      'CommunicationEmailLog.xlsx'
    );
  }

  private updateDataGridConfig(): void {
    this.notesGridData = DataGridVO.create({
      customHeaders: this.notesHeaders,
      data: this.notesRows,
      visibleColumns: this.visibleNotesColumns,
      showQueueActions: false,
      showActionsColumn: true,
      role: 'lookup-communication-notes',
      activeTab: 'lookup-communication-notes',
      disableApplicationClick: false
    });

    this.emailGridData = DataGridVO.create({
      customHeaders: this.emailLogHeaders,
      data: this.emailRows,
      visibleColumns: this.visibleEmailColumns,
      showQueueActions: false,
      showActionsColumn: true,
      role: 'lookup-communication-email-log',
      activeTab: 'lookup-communication-email-log',
      disableApplicationClick: false
    });
  }

  private initializeColumns(): void {
    this.allNotesColumns = this.notesHeaders.map(header => ({ key: header.dataField, label: header.caption || header.dataField }));
    this.allEmailColumns = this.emailLogHeaders.map(header => ({ key: header.dataField, label: header.caption || header.dataField }));

    this.allNotesColumns.forEach(column => {
      if (typeof this.visibleNotesColumns[column.key] === 'undefined') {
        this.visibleNotesColumns[column.key] = true;
      }
    });

    this.allEmailColumns.forEach(column => {
      if (typeof this.visibleEmailColumns[column.key] === 'undefined') {
        this.visibleEmailColumns[column.key] = true;
      }
    });
  }

  private mapCommunicationData(): void {
    const notesRaw = this.extractNotesData(this.communicationsData);
    const emailRaw = this.extractEmailData(this.communicationsData);

    this.notesRows = notesRaw
      .filter(item => {
        const documentNotes = this.pickValue(item, ['document_notes']);
        const noteType = this.pickValue(item, ['type', 'note_type', 'communication_type', 'category']);
        return (documentNotes !== '-' && documentNotes !== '') && (noteType !== '-' && noteType !== '');
      })
      .map(item => ({
        type: this.pickValue(item, ['type', 'note_type', 'communication_type', 'category']),
        document_notes: this.pickValue(item, ['document_notes']),
         document_id: this.pickValue(item, [ 'document_id']),
        document_type: this.pickValue(item, ['document_type_description', 'document_type', 'doc_type', 'type_name']),
        document_category: this.pickValue(item, ['document_category', 'doc_type', 'type_name']),
        document_name: this.pickValue(item, ['document_name', 'file_name', 'document']),
        updated_date: this.formatDisplayDate(this.pickValue(item, ['uploaded_date'])),
        updated_by: this.pickValue(item, ['uploaded_by']),
         deletion_allowed_until: this.pickValue(item, ['deletion_allowed_until']),
        actions: ''
      }));

    if (!this.emailLogsLoadedFromApi) {
      this.emailRows = this.mapEmailRows(emailRaw);
    }
  }

  private mapEmailRows(emailRaw: CommunicationRow[]): CommunicationRow[] {
    return emailRaw.map((item, idx) => {
      if (idx === 0) {
        console.log('🔍 Raw email item fields:', Object.keys(item));
        console.log('🔍 Full raw item:', item);
        console.log('🔍 template_data in raw:', item['template_data']);
        console.log('🔍 template_used in raw:', item['template_used']);
      }
      return {
      ...item,
      date_sent: this.pickValue(item, ['dtDateEmailSent', 'date_email_sent', 'dateSent', 'date_sent', 'sent_date', 'created_date', 'dtCreatedDate', 'date']),
      recipient: this.pickValue(item, ['strRecipientName', 'recipientName', 'recipient_name', 'recipient', 'recipient_email', 'to']),
      sender: this.pickValue(item, ['sender']),
      subject: this.truncateWords(this.pickValue(item, ['strSubject', 'subject', 'email_subject']), 10),
      subject_full: this.pickValue(item, ['strSubject', 'subject', 'email_subject']),
      status: (() => { const s = this.pickValue(item, ['strStatus', 'cd_status', 'status', 'delivery_status']); return s.toLowerCase() === 'sent' ? 'Delivered' : s; })(),
      body: this.pickValue(item, ['email_body', 'body', 'message', 'content', 'emailContent', 'description']),
      template_data: item['template_data'] || null,
      template_used: item['template_used'] || null,
      actions: ''
     };
    });
  }

   viewEmailLog(row: CommunicationRow): void {
    this.selectedEmailLog = row;
    let emailBody = String(row['body'] ?? row['email_content'] ?? '-');
    emailBody = emailBody.replace(/^=+/, '').trim();
    const templateData = row['template_data'];
    const templateUsed = row['template_used'];
    const templateUsedStr = String(templateUsed || '').trim().toLowerCase();
    const isN8nEmail = !templateUsed || templateUsedStr === '' || templateUsedStr === 'null';
    console.log('📧 Email Log Debug:', {
      templateUsed,
      templateUsedStr,
      isN8nEmail,
      hasTemplateData: !!templateData,
      templateDataKeys: templateData ? Object.keys(templateData) : []
    });
    
    if (isN8nEmail && templateData) {
      const beforeBody = emailBody.substring(0, 100);
      emailBody = this.applyTemplateDataToBody(emailBody, templateData);
      const afterBody = emailBody.substring(0, 100);
      console.log('✅ Template substitution applied:', { beforeBody, afterBody });
    } else {
      console.log('⚠️ Template substitution SKIPPED:', { isN8nEmail, hasData: !!templateData });
    }
  emailBody = this.enrichEmailBodyStyles(emailBody);
    this.sanitizedEmailBody = this.sanitizer.bypassSecurityTrustHtml(emailBody);
    this.viewEmailModalRef = this.modalService.open(this.viewEmailModal, {
      centered: true,
      backdrop: 'static',
      keyboard: true,
          windowClass: 'communication-view-email-popup',

    });
  }

  // private enrichEmailBodyStyles(html: string, imageMap?: Record<string, string>): string {
  //   if (!html) return html;
    
  //   // Replace class-based buttons with inline-styled buttons
  //   html = html.replace(
  //     /<a\s+([^>]*?)class="btn"([^>]*)>/gi,
  //     '<a $1 style="display: inline-block; padding: 10px 20px; background: #005A9C; color: white !important; text-decoration: none; border-radius: 4px; font-weight: 500; font-family: sans-serif; font-size: 14px;" $2>'
  //   );
    
  //   // Replace cid: image sources with actual URLs if mapping provided
  //   if (imageMap && Object.keys(imageMap).length > 0) {
  //     html = html.replace(/src="cid:([^"]*)"([^>]*>)/gi, (match, cidRef, rest) => {
  //       const actualUrl = imageMap[cidRef];
  //       return actualUrl ? `src="${actualUrl}"${rest}` : `src="" style="display:none;"${rest}`;
  //     });
  //   } else {
  //     // Hide cid: images if no mapping available
  //     html = html.replace(/src="cid:[^"]*"/gi, 'src="" style="display:none;"');
  //   }
    
  //   return html;
  // }

  // private extractImageMap(row: CommunicationRow): Record<string, string> {
  //   // Look for image mapping in various possible locations
  //   const imageMap: Record<string, string> = {};
    
  //   const imageMappingField = row['image_map'] ?? 
  //                            row['imageMap'] ?? 
  //                            row['cid_map'] ?? 
  //                            row['cidMap'] ?? 
  //                            row['images'] ?? 
  //                            null;
    
  //   if (imageMappingField && typeof imageMappingField === 'object') {
  //     Object.assign(imageMap, imageMappingField);
  //   }
    
  //   return imageMap;
  // }

  private enrichEmailBodyStyles(html: string, isN8nEmail: boolean = false): string {
    if (!html) return html;

    // For n8n emails: wrap with CSS class (styles defined in component.scss)
    if (isN8nEmail) {
      html = `<div class="n8n-email-wrapper">${html}</div>`;
    }

    // Replace class-based buttons with inline-styled buttons
    html = html.replace(
      /<a\s+([^>]*?)class="btn"([^>]*)>/gi,
      '<a $1 style="display: inline-block; padding: 12px 24px; background: #005A9C; color: white !important; text-decoration: none; border-radius: 4px; font-weight: 500; font-family: sans-serif; font-size: 14px;" $2>'
    );

    // Replace cid: image sources with Nevada education logo URL
    const eduLogoUrl = 'https://nevadadocs.blob.core.windows.net/customuserflow/edu-logo.svg';
    html = html.replace(/src="cid:[^"]*"/gi, `src="${eduLogoUrl}"`);

    // Enhance logo image sizing
    if (isN8nEmail) {
      html = html.replace(
        /(<img\s+[^>]*?class="logo"[^>]*?)\s*\/?>/gi,
        '$1 style="max-width: 400px; width: 100%; height: auto; display: block; margin: 16px auto; border-radius: 4px;" />'
      );
    } else {
      html = html.replace(
        /(<img\s+[^>]*?class="logo"[^>]*?)\s*\/?>/gi,
        '$1 style="max-width: 250px; width: 100%; height: auto; display: block; margin-bottom: 10px;" />'
      );
    }

    // Add sizing to all images without existing styles
    html = html.replace(
      /(<img\s+(?!.*style)[^>]*?)\s*\/?>/gi,
      '$1 style="max-width: 100%; height: auto; display: block; margin: 8px 0; word-break: break-word;" />'
    );

    return html;
  }

  closeViewEmailModal(): void {
    this.viewEmailModalRef?.close();
    this.viewEmailModalRef = null;
    this.selectedEmailLog = null;
    this.sanitizedEmailBody = null;
  }

  getEmailFieldValue(row: CommunicationRow | null, keys: string[]): string {
    if (!row) {
      return '-';
    }

    for (const key of keys) {
      const value = row[key];
      if (value !== null && value !== undefined && String(value).trim() !== '' && String(value).trim() !== '-') {
        return String(value);
      }
    }

    return '-';
  }

  private setUploadedFile(file: File): void {
    const maxSize = 15 * 1024 * 1024;
    if (file.size > maxSize) {
      this.uploadError = 'The selected file exceeds the maximum allowed size of 15 MB.';
      this.uploadData = { file: null, fileName: '', type: '' };
      this.saveEnable = true;
      return;
    }
    this.uploadData.file = file;
    this.uploadData.fileName = file.name;
    this.uploadData.type = file.type || '';
    this.uploadError = null;
    this.saveEnable = false;
  }

  private resetAddNoteForm(): void {
    this.addNoteForm.reset({
      date: new Date().toLocaleDateString('en-US'),
      noteType: '',
      notes: '',
      supportingDocument: ''
    });
    this.showDatePickerInput = false;
    this.selectedUploadMeta = { fileName: '', contentType: '', file: null };
    this.uploadError = null;
    this.saveEnable = true;
    this.currentUploadSection = 'academic-Background';
  }

  /**
   * Prefer CMS optionaldata.section_name, then known category labels (e.g. Proof of Service → Veteran Status),
   * then mapped currentUploadSection. Never keep a stale Identity section for unmapped categories.
   */
  private resolveUploadProfileTabSection(formIdLabelMap: Record<string, string>): string {
    const selectedCat = this.categoryOptions.find(
      (c) => String(c.key) === String(this.selectedUploadMeta.category ?? '')
    );
    const fromOptional = resolveProfileTabSectionFromLookupCategory(selectedCat, '');
    if (fromOptional) {
      return fromOptional;
    }
    const catValue = String(selectedCat?.value ?? '').trim().toLowerCase();
    if (catValue === 'proof of service' || catValue.includes('proof of service')) {
      return 'Veteran Status';
    }
    const fromSection = formIdLabelMap[this.currentUploadSection];
    if (fromSection) {
      return fromSection;
    }
    return 'communication_notes';
  }

  private formatDisplayDate(value: string): string {
    if (!value) return '-';
    const d = new Date(value);
    if (isNaN(d.getTime())) return value;
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  private getCurrentUserName(): string {
    try {
      const userRaw = sessionStorage.getItem('user');
      if (!userRaw) return 'System';
      const user = JSON.parse(userRaw);
      const fullName = [user?.first_name, user?.middle_name, user?.last_name].filter(Boolean).join(' ').trim();
      if (fullName) return fullName;
      return user?.email || user?.username || 'System';
    } catch {
      return 'System';
    }
  }

  formatDateInput(event: Event): void {
    const target = (event.target as HTMLInputElement);
    const value = (target?.value || '').replace(/\D/g, '');
    const limited = value.length > 8 ? value.substring(0, 8) : value;
    let formatted = limited;
    if (limited.length >= 5) formatted = `${limited.substring(0, 2)}/${limited.substring(2, 4)}/${limited.substring(4, 8)}`;
    else if (limited.length >= 3) formatted = `${limited.substring(0, 2)}/${limited.substring(2, 4)}`;
    else if (limited.length >= 1) formatted = limited.substring(0, 2);
      this.addNoteForm.get('date')?.setValue(formatted, { emitEvent: false });
    
  }

   openDatePicker( event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    const dobInput = document.getElementById('communication_note_date');
    if (!dobInput) return;
    const rect = dobInput.getBoundingClientRect();
    const dateInput = document.createElement('input') as HTMLInputElement;
    dateInput.type = 'date';
    dateInput.style.position = 'absolute';
    dateInput.style.top = rect.top + window.scrollY + 5 + 'px';
    dateInput.style.left = rect.left + 'px';
    dateInput.style.width = '120px';
    dateInput.style.height = '35px';
    dateInput.style.opacity = '0.01';
    dateInput.style.border = 'none';
    dateInput.style.zIndex = '9999';
    dateInput.style.pointerEvents = 'auto';
    dateInput.max = this.currentDate;
    // dateInput.min = new Date().toISOString().split('T')[0];
    const currentValue = this.addNoteForm.get('date')?.value;
    if (currentValue && currentValue.includes('/')) {
      const parts = currentValue.split('/');
      if (parts.length === 3 && parts[2].length === 4) {
        const month = parts[0].padStart(2, '0');
        const day = parts[1].padStart(2, '0');
        const year = parts[2];
        dateInput.value = `${year}-${month}-${day}`;
      }
    }
    document.body.appendChild(dateInput);
    const cleanup = () => {
      if (document.body.contains(dateInput)) {
        dateInput.removeEventListener('change', changeHandler);
        dateInput.removeEventListener('blur', blurHandler);
        document.body.removeChild(dateInput);
      }
    };
    const changeHandler = (changeEvent: Event) => {
      const target = (changeEvent.target as HTMLInputElement);
      const selectedDate = target?.value;
      if (selectedDate) {
        const dateParts = selectedDate.split('-');
        if (dateParts.length === 3) {
          const formattedDate = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
            this.addNoteForm.get('date')?.setValue(formattedDate);
            this.addNoteForm.get('date')?.markAsTouched();
            this.addNoteForm.get('date')?.updateValueAndValidity();
          } 
      }
      cleanup();
    };
    const blurHandler = () => setTimeout(cleanup, 100);
    dateInput.addEventListener('change', changeHandler);
    dateInput.addEventListener('blur', blurHandler);
    dateInput.focus();
    const inputEl = dateInput as HTMLInputElement;
    if (typeof (inputEl as any).showPicker === 'function') {
      try {
        (inputEl as any).showPicker();
      } catch {
        inputEl.click();
      }
    } else {
      inputEl.click();
    }
  }
  validateDate = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    let selectedDate: Date;
    const val = control.value;
    if (typeof val !== 'string') return null;
    if (val.includes('/')) {
      const parts = val.split('/');
      if (parts.length !== 3) return { futureDate: true };
      const month = parseInt(parts[0], 10);
      const day = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900) return { futureDate: true };
      selectedDate = new Date(year, month - 1, day);
      if (selectedDate.getMonth() !== month - 1 || selectedDate.getDate() !== day || selectedDate.getFullYear() !== year) return { futureDate: true };
    } else {
      selectedDate = new Date(val);
      if (isNaN(selectedDate.getTime())) return { futureDate: true };
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    if (selectedDate > today) return { futureDate: true };
    const user = JSON.parse(this.user);
    const dateOfBirth = user?.dob
    const dob = new Date(dateOfBirth);
    dob.setHours(0, 0, 0, 0);
    // ✅ Selected date BEFORE DOB → error
    if (selectedDate < dob) {
      return { beforeDob: true };
    }
  };

  private extractNotesData(source: unknown): CommunicationRow[] {
    if (!source) return [];

    if (Array.isArray(source)) {
      const wrapped = source.find(item => {
        if (!item || typeof item !== 'object') return false;
        const row = item as Record<string, unknown>;
        return Array.isArray(row.notes) || Array.isArray(row.note_log) || Array.isArray(row.p_notes);
      }) as Record<string, unknown> | undefined;

      if (wrapped) {
        if (Array.isArray(wrapped.notes)) return wrapped.notes as CommunicationRow[];
        if (Array.isArray(wrapped.note_log)) return wrapped.note_log as CommunicationRow[];
        if (Array.isArray(wrapped.p_notes)) return wrapped.p_notes as CommunicationRow[];
      }
      return source.filter(item => this.looksLikeNote(item));
    }

    if (typeof source === 'object') {
      const obj = source as Record<string, unknown>;
      const notesCandidates = [
        obj.notes,
        obj.note,
        obj.note_log,
        obj.notes_log,
        obj.p_notes,
        obj.note_data
      ];
      for (const candidate of notesCandidates) {
        if (Array.isArray(candidate)) return candidate as CommunicationRow[];
      }
      return this.looksLikeNote(obj) ? [obj] : [];
    }

    return [];
  }

  private extractEmailData(source: unknown): CommunicationRow[] {
    if (!source) return [];

    if (Array.isArray(source)) {
      const wrapped = source.find(item => {
        if (!item || typeof item !== 'object') return false;
        const row = item as Record<string, unknown>;
        return Array.isArray(row.email_log) || Array.isArray(row.email_logs) || Array.isArray(row.p_email_log);
      }) as Record<string, unknown> | undefined;

      if (wrapped) {
        if (Array.isArray(wrapped.email_log)) return wrapped.email_log as CommunicationRow[];
        if (Array.isArray(wrapped.email_logs)) return wrapped.email_logs as CommunicationRow[];
        if (Array.isArray(wrapped.p_email_log)) return wrapped.p_email_log as CommunicationRow[];
      }
      return source.filter(item => this.looksLikeEmail(item));
    }

    if (typeof source === 'object') {
      const obj = source as Record<string, unknown>;
      const emailCandidates = [
        obj.email_log,
        obj.email_logs,
        obj.emails,
        obj.p_email_log,
        obj.p_emails
      ];
      for (const candidate of emailCandidates) {
        if (Array.isArray(candidate)) return candidate as CommunicationRow[];
      }
      return this.looksLikeEmail(obj) ? [obj] : [];
    }

    return [];
  }

  private looksLikeNote(item: unknown): boolean {
    if (!item || typeof item !== 'object') return false;
    const row = item as Record<string, unknown>;
    return (
      this.hasAny(row, ['notes', 'note', 'description', 'message', 'comments']) ||
      this.hasAny(row, ['document_name', 'file_name']) ||
      this.hasAny(row, ['note_type'])
    );
  }

  private looksLikeEmail(item: unknown): boolean {
    if (!item || typeof item !== 'object') return false;
    const row = item as Record<string, unknown>;
    return (
      this.hasAny(row, ['recipient', 'recipient_email', 'to']) ||
      this.hasAny(row, ['sender', 'sender_email', 'from']) ||
      this.hasAny(row, ['subject', 'email_subject'])
    );
  }

  private hasAny(source: Record<string, unknown>, keys: string[]): boolean {
    return keys.some(key => {
      const value = source[key];
      return value !== null && value !== undefined && String(value).trim() !== '';
    });
  }

  private pickValue(source: Record<string, unknown>, keys: string[]): string {
    for (const key of keys) {
      const value = source[key];
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        return String(value);
      }
    }
    return '-';
  }

  private truncateWords(text: string, maxWords: number): string {
    if (!text || text === '-') return text;
    const words = text.trim().split(/\s+/);
    if (words.length <= maxWords) return text;
    return words.slice(0, maxWords).join(' ') + '...';
  }

  //  downloadNoteDocument(row: CommunicationRow): void {
  //   const documentIdRaw = row['document_id'] ?? row['documentId'];
  //   const documentId = documentIdRaw !== null && documentIdRaw !== undefined ? Number(documentIdRaw) : NaN;

  //   if (!Number.isFinite(documentId) || documentId <= 0) {
  //     this.alertService.error('Document information is missing');
  //     return;
  //   }

  //   const payload = {
  //     applicationId: row['application_id'] || this.applicationId || '',
  //     documentId,
  //     documentType: row['document_type'] || row['type'] || ''
  //   };

  //   this.httpService
  //     .post(API_ENDPOINTS.DOCUMENT_DOWNLOAD, payload)
  //     .pipe(take(1))
  //     .subscribe({
  //       next: (response: any) => {
  //         const fileUrl =
  //           response?.data?.data?.p_document_blob?.strfileHash ||
  //           response?.data?.data?.p_document_blob?.file_hash ||
  //           response?.data?.data?.p_document_blob?.fileHash;

  //         if (!fileUrl) {
  //           this.alertService.error('Failed to download document');
  //           return;
  //         }

  //         fetch(fileUrl)
  //           .then(res => res.blob())
  //           .then(blob => {
  //             const fileName = String(row['file_name'] || row['document_name'] || `document_${documentId}`);
  //             FileSaver.saveAs(blob, fileName);
  //             this.alertService.success('Document downloaded successfully');
  //           })
  //           .catch(() => {
  //             this.alertService.error('Failed to download document file');
  //           });
  //       },
  //       error: () => {
  //         this.alertService.error('Failed to download document. Please try again.');
  //       }
  //     });
  // }

  downloadNoteDocument(row: CommunicationRow): void {
    const documentIdRaw = row['document_id'] ?? row['documentId'];
    const profileDocumentUploadId = documentIdRaw !== null && documentIdRaw !== undefined ? Number(documentIdRaw) : NaN;

    if (!Number.isFinite(profileDocumentUploadId) || profileDocumentUploadId <= 0) {
      this.alertService.error('Document information is missing');
      return;
    }

    const payload = { profile_document_upload_id: profileDocumentUploadId };

    this.httpService
      .post(API_ENDPOINTS.EDUCATOR_COMMUNICATION_DOWNLOAD, payload)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          const fileUrl = this.resolveFileUrl(response);

          if (!fileUrl) {
            this.alertService.error('Failed to download document');
            return;
          }

          fetch(fileUrl)
            .then(res => res.blob())
            .then(blob => {
              const fileName = String(row['document_name'] || `document_${profileDocumentUploadId}`);
              FileSaver.saveAs(blob, fileName);
              // this.alertService.success('Document downloaded successfully');
            })
            .catch(() => {
              this.alertService.error('Failed to download document file');
            });
        },
        error: () => {
          this.alertService.error('Failed to download document. Please try again.');
        }
      });
  }

  viewNoteDocument(row: CommunicationRow): void {
    const documentIdRaw = row['document_id'] ?? row['documentId'];
    const profileDocumentUploadId = documentIdRaw !== null && documentIdRaw !== undefined ? Number(documentIdRaw) : NaN;

    if (!Number.isFinite(profileDocumentUploadId) || profileDocumentUploadId <= 0) {
      this.alertService.error('Document information is missing');
      return;
    }

    const payload = { profile_document_upload_id: profileDocumentUploadId };

    this.httpService
      .post(API_ENDPOINTS.EDUCATOR_COMMUNICATION_DOWNLOAD, payload)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          const fileUrl = resolveEducatorDocumentFileUrl(response);

          if (!fileUrl) {
            this.alertService.error('Failed to retrieve document URL');
            return;
          }

          const fileName = String(row['file_name'] ?? row['fileName'] ?? '');
          this.documentPreviewModal.openFromUrl(fileUrl, fileName || undefined);
        },
        error: () => {
          this.alertService.error('Failed to view document. Please try again.');
        }
      });
  }

  private resolveFileUrl(response: any): string | null {
    return (
      response?.data?.data?.p_document_blob?.file_url ||
      response?.data?.data?.p_document_blob?.fileUrl ||
      response?.data?.data?.p_document_blob?.strfileHash ||
      response?.data?.data?.p_document_blob?.file_hash ||
      response?.data?.data?.p_document_blob?.fileHash ||
      response?.data?.file_url ||
      response?.data?.fileUrl ||
      response?.data?.url ||
      response?.file_url ||
      response?.fileUrl ||
      null
    );
  }
    hasValidDocumentId(row: CommunicationRow): boolean {
    const value = row?.['document_id'] ?? row?.['documentId'];
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0;
  }
  deleteNote(row: CommunicationRow): void {
    const documentId = row['document_id'];
    const personId = this.personId;
    if (!documentId || !personId) {
      this.alertService.error('Note information is missing');
      return;
    }
   const payload = {
      person_id: personId,
      document_id: documentId
    };
   
    this.httpService
      .patch(API_ENDPOINTS.EDUCATOR_NOTES_DELETE, payload)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.alertService.success('Note deleted successfully');
          this.refreshCommunicationsData();
        },
        error: () => {
          this.alertService.error('Failed to delete note. Please try again.');
        }
      });
  }

   private refreshCommunicationsData(): void {
      if (!this.personId) return;
      this.httpService
        .post(API_ENDPOINTS.EDUCATOR_DASHBOARD_DATA, { personId: Number(this.personId) })
        .pipe(take(1))
        .subscribe({
          next: (response: any) => {
            const row = response?.data?.data?.[0];
            if (row) {
              this.communicationsData = row.p_communications;
              this.mapCommunicationData();
              this.updateDataGridConfig();
              this.refreshed.emit({
                section: 'communication',
                refreshedData: row
              });

            }
          },
          error: () => {
            // silently fail — data already visible from previous load
          }
        });
    }

      onDateFocus(): void {
    this.showDatePickerInput = true;
  }

  onDateBlur(): void {
    const selectedDate = this.addNoteForm.get('date')?.value;
    this.showDatePickerInput = !!selectedDate;
  }

 
 // viewEmailLog(row: CommunicationRow): void {
  //   const emailText = this.buildEmailLogText(row);
  //   const popup = window.open('', '_blank');
  //   if (!popup) {
  //     this.alertService.error('Popup blocked. Please allow popups and try again.');
  //     return;
  //   }
  //   popup.document.write(`<pre style="font-family: Arial, sans-serif; white-space: pre-wrap; margin: 16px;">${emailText}</pre>`);
  //   popup.document.close();
  // }
  downloadEmailLog(row: CommunicationRow): void {
    const emailText = this.buildEmailLogText(row);
    const subject = String(row['subject'] ?? 'email').replace(/[^a-z0-9_-]/gi, '_');
    const fileName = `${subject || 'email'}_log.txt`;
    const blob = new Blob([emailText], { type: 'text/plain;charset=utf-8' });
    FileSaver.saveAs(blob, fileName);
  }

  resendEmailLog(row: CommunicationRow): void {
      this.pendingResendRow = row;
  this.resendEmailModalRef = this.modalService.open(this.resendEmailModal, {
    centered: true,
    backdrop: 'static',
    keyboard: true,
    windowClass: 'communication-resend-email-popup'
  });
    // this.alertService.success('Resend email request submitted.');
  }

  closeResendEmailModal(): void {
  this.resendEmailModalRef?.close();
  this.resendEmailModalRef = null;
  this.pendingResendRow = null;
}

confirmResendEmail(): void {
  if (this.pendingResendRow) {
        try {
      const emailLogId = Number(this.pendingResendRow.email_log_id);
      if (!emailLogId || Number.isNaN(emailLogId) || emailLogId <= 0) {
        this.alertService.error('Invalid email log id.');
        return;
      }

      const userId = this.getCurrentUserId();
      
      const payload = {
        id: emailLogId,
        userId: userId
      };

      const url = `${API_ENDPOINTS.RESEND_EMAIL_LOG_BY_ID}`;
      this.httpService.post(url, payload)
        .pipe(take(1))
        .subscribe({
          next: (response: any) => {

            if (!response) {
              this.alertService.warn('No response received from server.');
              return;
            }
            if (response.success === false) {
              this.alertService.error(
                response.message || 'Failed to resend email.'
              );
              return;
            }
            this.alertService.success(
              response.message || 'Email resent successfully.'
            );
            this.emailLogsLoadedFromApi = false;
            this.emailLogsPersonId = null;
            this.loadEmailLogs();
          },
          error: (error) => {
            console.error('Resend email API error:', error);
            let errorMessage = 'Failed to resend email.';
            this.alertService.error(errorMessage);
          }
        });

    } catch (error: any) {
      console.error('Unexpected error while resending email:', error);
      this.alertService.error(
        error?.message || 'Unexpected error occurred while resending email.'
      );
    }
  }
  this.closeResendEmailModal();
}

   private buildEmailLogText(row: CommunicationRow): string {
    // const dateSent = String(row['date_sent'] ?? '-');
    const dateSent = this.formatDisplayDate(String(row['date_sent'] ?? '')) || '-';
    const recipient = String(row['recipient'] ?? '-');
    const sender = String(row['sender'] ?? '-');
    const subject = String(row['subject'] ?? '-');
    const status = String(row['status'] ?? '-');
    const rawBody = String(row['body'] ?? '');
    const cleanBody = this.stripHtmlTags(rawBody).trim();

    return [
      `Date Sent: ${dateSent}`,
      `Recipient: ${recipient}`,
      `Sender: ${sender}`,
      `Subject: ${subject}`,
      `Status: ${status}`,
      '',
      cleanBody || '(No content available)'
    ].join('\n');
  }

  private stripHtmlTags(html: string): string {
    if (!html) return '';
    const div = document.createElement('div');
    div.innerHTML = html;
    let text = div.textContent || div.innerText || '';
    
    // Normalize whitespace: remove extra spaces and indentation
    text = text.replace(/[ \t]+/g, ' '); // Replace multiple spaces/tabs with single space
    text = text.replace(/\n[ \t]+/g, '\n'); // Remove leading spaces after newlines
    text = text.replace(/\n+/g, '\n'); // Replace multiple newlines with single newline
    
    return text;
  }
  openDeleteModal(row: CommunicationRow): void {
    const options: NgbModalOptions = { backdrop: 'static', size: 'md', centered: true, windowClass: 'custom-delete-record-modal' };
    const modalRef = this.modalService.open(ModalComponent, options);
    const config: ModalConfig = {
      buttons: [
        { text: 'Cancel', code: 'N', btnOutline: true },
        { text: 'Delete', code: 'Y', btnOutline: false }
      ],
      heading: 'Delete Record',
      headingAlign: 'left',
      modalContent: 'Are you sure you want to delete this record? This action cannot be undone.',
      modalContentClass: 'actdelcontent',
      hasTemplate: true,
      isDangerButton: true,
      panelClass: 'lookup-act-delete-modal'
    };
    modalRef.componentInstance.modalConfig = config;
    modalRef.componentInstance.emitData.pipe(take(1)).subscribe((response: any) => {
      modalRef.close();
      if (response?.code === 'Y' || response?.confirmed === true) {
        this.deleteNote(row);
      }
    });
  }


// showCancelUploadConfirmation(): void {
//   const modalRef = this.modalService.open(ModalComponent, {
//     centered: true,
//     windowClass: 'dashboard-no-header-border',
//     backdrop: 'static',
//     keyboard: false
//   });

//   modalRef.componentInstance.modalConfig = {
//     heading: 'Cancel File Upload',
//     modalContent: 'You have started uploading a file but have not yet saved it. Are you sure you want to cancel? Any unsaved changes will be lost.',
//     hasDropdown: false,
//     hasTemplate: true,
//     align: false,
//     panelClass: 'cancelUploadModal',
//     buttons: [
//       { text: 'Yes, Cancel', code: 'Y' },
//       { text: 'No, Continue', code: 'N', btnOutline: true }
//     ]
//   };

//   modalRef.componentInstance.emitData.subscribe((data: any) => {
//     if (data?.buttonCode === 'Y') {
//       modalRef.close();
//       this.closeUploadPopup();
//     } else if (data?.buttonCode === 'N') {
//       modalRef.close();
//     }
//     this.cd.detectChanges();
//   });
// }

showCancelUploadConfirmation(): void {
  if (this.uploadData.file || this.uploadData.fileName || this.uploadDocMetaForm.dirty) {
    const modalRef = this.modalService.open(ModalComponent, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.modalConfig = getCancelFileUploadModalConfig();
    modalRef.componentInstance.emitData.subscribe((data: any) => {
      if (data?.buttonCode === 'Y') {
        this.closeUploadPopup();
      }
      modalRef.close();
      this.cd.detectChanges();
    });
  } else {
    this.closeUploadPopup();
  }
}



  /** Load all upload categories from System A (SUPPORTING-DOCUMENT-CATEGORY master lookup). */
  private loadDocCategoryOptions(): void {
    const applications = this.educatorDashboardRow?.p_application as any[];

    const appType = applications?.length
      ? applications[0]?.app_type ?? ''
      : '';

    const excludedCategories = [
      'License Revoked/Suspended/Denied (Past)',
      'License Suspended/Revoked (Current)',
      'Professional Discipline',
      'Criminal Conviction',
      'Sexual Offense Arrest (Against Minor)',
      'Child Abuse Substantiated',
      'Child Support Disclosure'
    ];

    this.supportingDocLookupService
      .getAllTopLevelCategories()
      .pipe(take(1))
      .subscribe((cats: SupportingDocumentGridOption[]) => {
        console.log('🔥 ALL SYSTEM A CATEGORIES WITH EXACT VALUES:', cats.map(c => ({ key: c.key, value: c.value })));
        console.log('Loaded categories from System A:', cats);
        let filteredCats = cats.filter(
          cat => !excludedCategories.includes(cat.value ?? '')
        );
        console.log('Filtered categories after exclusions:', filteredCats);
        if (appType.includes('ARL')) {
          filteredCats = filteredCats.filter(
            cat => !cat.value?.startsWith('Apprentice')
          );
        } else if (appType.includes('Apprentice')) {
          filteredCats = filteredCats.filter(
            cat => !cat.value?.startsWith('ARL')
          );
        } else {
          filteredCats = filteredCats.filter(cat => {
            const value = cat.value ?? '';
            return !value.startsWith('ARL') &&
              !value.startsWith('Apprentice');
          });
        }

        this.categoryOptions = filteredCats;
      });
  }

  /** Called when user selects a category in the upload modal; loads matching types from System A. */
//   onCategoryChange(selectedKey: string): void {
//   this.filteredDocumentTypeOptions = [];
//   this.uploadDocMetaForm.get('type')?.setValue('');

//   if (!selectedKey) return;

//   const selectedCat = this.categoryOptions.find(c => c.key === selectedKey);
//   if (!selectedCat) return;

//   const personId = this.personId;
//   if (!personId) {
//     return;
//   }

//   this.httpService
//     .get(`${API_ENDPOINTS.SEARCH_COMMUNICATION_DOCUMENT_TYPES}/${personId}/${selectedKey}`)
//     .pipe(take(1))
//     .subscribe({
//       next: (response: any) => {
//   const types: SupportingDocumentGridOption[] = Array.isArray(response?.data)
//     ? response.data
//         .map((item: any) => {
//           const cdType = item?.cd_document_type ?? '';
//           const isNumber = !isNaN(Number(cdType));

//           return {
//             key: String(item?.key ?? cdType ?? ''),
//             value: isNumber ? String(item?.document_type ?? '').trim() : String(cdType).trim()
//           };
//         })
//         .filter((item: SupportingDocumentGridOption) => item.key && item.value)
//     : [];
//   this.filteredDocumentTypeOptions = types;
// },
//       error: () => {
//         this.filteredDocumentTypeOptions = [];
//       }
//     });
// }

onCategoryChange(selectedKey: string): void {
  this.filteredDocumentTypeOptions = [];
  this.uploadDocMetaForm.get('type')?.setValue(null);
  this.uploadDocMetaForm.get('type')?.markAsUntouched();
  this.uploadDocMetaForm.get('type')?.markAsPristine();
  // Reset to safe default so stale state never bleeds into next save
  this.currentUploadSection = 'academic-Background';

  if (!selectedKey) return;

  const selectedCat = this.categoryOptions.find(c => c.key === selectedKey);
  if (!selectedCat) return;
  // Category display labels from System A (must match upload dropdown values)
  const sectionTabLabelMap: Record<string, string> = {
    'name-history': 'Proof of Legal Name Change',
    'identity-contact': 'Proof of Photo Identification',
    'veteran-status': 'Proof of Service',
    'nevada-testing': 'Nevada Praxis Testing Score Report',
    'out-of-state-testing': 'Other Testing Score Report',
    'history-disclosure': 'History Disclosure',
    'academic-Background': 'Academic Background',
    'employment_prof_dev': 'District / Charter Training Transcript',
    'employment_prof_dev_alt': 'District / Charter Employment',
    'verifiable-teaching': 'Verifiable Teaching Experience',
    'verifiable-business': 'Verifiable Business and Industry Work Experience',
    'Additional_prof_dev': 'Professional Development Certificate',
    'Additional_prof_dev_alt': 'Additional Professional Development',
    'out-of-state-licensure': 'Out-of-State or Country Licensure'
  };

  const selectedCatValue = String(selectedCat.value || '').trim();
  const selectedCatValueLower = selectedCatValue.toLowerCase();

  // Prefer CMS section_name when present (prof-dev + Veteran Status, etc.)
  const optionalSectionName = String(
    selectedCat.optionaldata?.section_name ?? selectedCat.optionaldata?.sectionName ?? ''
  ).trim();
  const sectionNameToKey: Record<string, string> = {
    'Additional Professional Development': 'Additional_prof_dev',
    'District / Charter Employment': 'employment_prof_dev',
    'Veteran Status': 'veteran-status',
    'Identity and Contact Information': 'identity-contact',
    'Name History': 'name-history',
    'Academic Background': 'academic-Background'
  };
  let matchedSectionKey: string | undefined = sectionNameToKey[optionalSectionName];

  // Exact match on category display label — normalise _alt aliases to their real section key
  if (!matchedSectionKey) {
    const aliasToReal: Record<string, string> = {
      'employment_prof_dev_alt': 'employment_prof_dev',
      'Additional_prof_dev_alt': 'Additional_prof_dev'
    };
    let rawMatchedKey = Object.entries(sectionTabLabelMap).find(
      ([_, displayLabel]) => displayLabel === selectedCatValue
    )?.[0];
    matchedSectionKey = rawMatchedKey ? (aliasToReal[rawMatchedKey] ?? rawMatchedKey) : undefined;
  }

  if (!matchedSectionKey) {
    if (selectedCatValueLower.includes('proof of service')) {
      matchedSectionKey = 'veteran-status';
    } else if (
      selectedCatValueLower.includes('nevada') &&
      (selectedCatValueLower.includes('praxis') || selectedCatValueLower.includes('testing'))
    ) {
      matchedSectionKey = 'nevada-testing';
    } else if (
      selectedCatValueLower.includes('other testing') ||
      (selectedCatValueLower.includes('out of state') && selectedCatValueLower.includes('testing'))
    ) {
      matchedSectionKey = 'out-of-state-testing';
    } else if (
      selectedCatValueLower.includes('additional') &&
      selectedCatValueLower.includes('professional')
    ) {
      matchedSectionKey = 'Additional_prof_dev';
    } else if (
      selectedCatValueLower.includes('professional development')
    ) {
      matchedSectionKey = 'Additional_prof_dev';
    } else if (
      selectedCatValueLower.includes('district') &&
      selectedCatValueLower.includes('charter')
    ) {
      matchedSectionKey = 'employment_prof_dev';
    }
  }

  if (matchedSectionKey) {
    this.currentUploadSection = matchedSectionKey as
      | 'name-history'
      | 'identity-contact'
      | 'veteran-status'
      | 'nevada-testing'
      | 'out-of-state-testing'
      | 'history-disclosure'
      | 'academic-Background'
      | 'employment_prof_dev'
      | 'verifiable-teaching'
      | 'verifiable-business'
      | 'Additional_prof_dev'
      | 'out-of-state-licensure'
      | 'programs-upload';
  } else {
    // Do not keep a prior Photo ID / Identity selection for unmapped categories
    this.currentUploadSection = 'academic-Background';
  }

  // employment_prof_dev / Additional_prof_dev: types come from educator's profile rows, not full lookup
  if (matchedSectionKey === 'employment_prof_dev') {
    const rows: any[] = (this.educatorDashboardRow?.['p_prof_dev_district_charter'] as any[]) ?? [];
    const names = ([...new Set<string>(
      rows.map((r: any) => String(r?.district_charter_name ?? '').trim()).filter((n: string) => !!n)
    )] as string[]).sort();
    this.filteredDocumentTypeOptions = names.map(n => ({ key: n, value: n } as SupportingDocumentGridOption));
    return;
  }
  if (matchedSectionKey === 'Additional_prof_dev') {
    const rows: any[] = (this.educatorDashboardRow?.['p_prof_dev_additional'] as any[]) ?? [];
    const names = ([...new Set<string>(
      rows.map((r: any) => String(r?.provider_name ?? '').trim()).filter((n: string) => !!n)
    )] as string[]).sort();
    this.filteredDocumentTypeOptions = names.map(n => ({ key: n, value: n } as SupportingDocumentGridOption));
    return;
  }

  const personId = this.personId;
  if (!personId) return;

  this.httpService
    .get(`${API_ENDPOINTS.SEARCH_COMMUNICATION_DOCUMENT_TYPES}/${personId}`)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        const allCategories: any[] = Array.isArray(response?.data?.data)
          ? response.data.data
          : [];

        const matchedCategory = allCategories.find(
          cat => cat.categoryKey === selectedKey
        );

        this.filteredDocumentTypeOptions = Array.isArray(matchedCategory?.types)
          ? matchedCategory.types
              .map((t: any) => ({
                key: String(t.typeKey ?? ''),
                value: String(t.typeValue ?? '').trim()
              }))
              .filter((t: SupportingDocumentGridOption) => t.key && t.value)
          : [];
      },
      error: () => {
        this.filteredDocumentTypeOptions = [];
      }
    });
}

private loadToastMessages(): void {
  this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES')
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.lookupToast = {};
        (response?.data || []).forEach((msg: { key?: string; value?: string }) => {
          if (msg.key != null && msg.value !== undefined) {
            this.lookupToast[msg.key] = msg.value;
          }
        });
      },
      error: () => {
        this.lookupToast = {};
      }
    });
}

onViewNote(data: CommunicationRow): void {
  this.selectedViewNote = { ...data };

  const typeLabel = String(data['type'] || '').trim().toLowerCase();
  const matchedType = this.noteTypeOptions.find(
    opt => opt.value.trim().toLowerCase() === typeLabel
  );
  this.viewNoteTypeKey = matchedType ? matchedType.key : null;

  // Resolve category/type using System A lookup (same source as upload).
  const categoryRaw = String(data['document_category'] || data['cd_document_category'] || '').trim();
  const matchedCategory = this.categoryOptions.find(
    c => c.key === categoryRaw || c.value.toLowerCase() === categoryRaw.toLowerCase()
  );
  this.viewDocumentCategoryId = matchedCategory?.key ?? null;

  if (matchedCategory) {
    this.supportingDocLookupService
      .getTypesByCategory(matchedCategory)
      .pipe(take(1))
      .subscribe({
        next: (types: SupportingDocumentGridOption[]) => {
          this.viewDocumentTypeOptions = types;
          const typeRaw = String(data['document_type'] || data['cd_document_type'] || '').trim();
          const matchedDocType = types.find(
            t => t.key === typeRaw || t.value.toLowerCase() === typeRaw.toLowerCase()
          );
          this.viewDocumentTypeId = matchedDocType?.key ?? null;
        },
        error: () => {
          this.viewDocumentTypeOptions = [];
          this.viewDocumentTypeId = null;
        }
      });
  } else {
    this.viewDocumentTypeOptions = [];
    this.viewDocumentTypeId = null;
  }

  this.viewNoteDetailModalRef = this.modalService.open(
    this.viewNoteDetailModal,
    {
      backdrop: 'static',
      centered: true,
      size: 'lg',
      windowClass: 'view-note-detail-modal'
    }
  );
}

closeViewNoteDetailModal(): void {
  this.selectedViewNote = null;
  this.viewNoteTypeKey = null;
  this.viewDocumentCategoryId = null;
  this.viewDocumentTypeId = null;
  this.viewDocumentTypeOptions = [];
  if (this.viewNoteDetailModalRef) {
    this.viewNoteDetailModalRef.close();
    this.viewNoteDetailModalRef = null;
  }
}

// DELETE this entire method from your .ts
// getViewNoteTypeKey(): number | null {
//   if (!this.selectedViewNote) return null;
//   const label = String(this.selectedViewNote['type'] || '').trim().toLowerCase();
//   const match = this.noteTypeOptions.find(
//     opt => opt.value.trim().toLowerCase() === label
//   );
//   return match ? match.key : null;
// }

  private loadEmailLogs(): void {
    const personId = this.personId ? Number(this.personId) : NaN;
    if (!Number.isFinite(personId) || personId <= 0) {
      return;
    }

    const personIdKey = String(personId);
    if (this.emailLogsLoadingPersonId === personIdKey || (this.emailLogsLoadedFromApi && this.emailLogsPersonId === personIdKey)) {
      return;
    }

    this.emailLogsLoadingPersonId = personIdKey;
    this.httpService
      .get(`${API_ENDPOINTS.EMAIL_LOGS_BY_PERSON}/${personId}`)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (this.emailLogsLoadingPersonId !== personIdKey || String(Number(this.personId)) !== personIdKey) {
            return;
          }

          const emailRaw = response.data;
          this.emailRows = this.mapEmailRows(emailRaw);
          this.emailLogsLoadedFromApi = true;
          this.emailLogsPersonId = personIdKey;
          this.emailLogsLoadingPersonId = null;
          this.updateDataGridConfig();
        },
        error: () => {
          if (this.emailLogsLoadingPersonId === personIdKey) {
            this.emailLogsLoadingPersonId = null;
          }
        }
      });
  }

isDeletionAllowed(row: CommunicationRow): boolean {
  const roleId = sessionStorage.getItem('role_id');

  if (roleId === '457' || roleId === '2') {
    return true;
  }

  const allowedUntil = row['deletion_allowed_until'];
  if (!allowedUntil) return false;

  return new Date() < new Date(String(allowedUntil));
}
  
onEditNote(data: any): void {
  const index = this.notesGridData?.data?.findIndex(
    (item: any) => item.document_id === data.document_id
  ) ?? -1;
  this.openEditNoteModal(data, index);
}

openEditNoteModal(row: any, index: number): void {
  this.selectedNote = { ...row };
  this.editNoteIndex = index;

  const rawDate = String(row.updated_date || '');
  const dateValue = rawDate.includes('T')
    ? this.formatDisplayDate(rawDate)   : rawDate === '-' ? '' : rawDate;

  const matchedNoteType = this.noteTypeOptions.find(
    opt => opt.value?.trim().toLowerCase() === String(row.type || '').trim().toLowerCase()
  );
  const noteTypeKey = matchedNoteType ? matchedNoteType.key : null;

  this.editNoteForm.patchValue({
    date:               dateValue,
    noteType:           noteTypeKey,
    supportingDocument: row.document_name || '',   
    notes:              row.document_notes || ''
  });

  this.editNoteForm.markAsPristine();
  this.editNoteForm.markAsUntouched();

  const options: NgbModalOptions = {
    backdrop: 'static',
    centered: true,
    size: 'xl',
    windowClass: 'edit-note-detail-modal'
  };
  this.editNoteModalRef = this.modalService.open(this.editNoteModal, options);
}


closeEditNoteModal(): void {
  this.selectedNote = null;
  this.editNoteForm.reset();
  this.editNoteForm.markAsPristine();
  this.editNoteForm.markAsUntouched();
  if (this.editNoteModalRef) {
    this.editNoteModalRef.close();
    this.editNoteModalRef = null;
  }
}

onEditNoteReset(): void {
  if (this.selectedNote) {
    const rawDate = String(this.selectedNote.updated_date || '');
    const dateValue = rawDate === '-' ? '' : rawDate;

    const matchedNoteType = this.noteTypeOptions.find(
      opt => opt.value?.trim().toLowerCase() === String(this.selectedNote.type || '').trim().toLowerCase()
    );
    const noteTypeKey = matchedNoteType ? matchedNoteType.key : null;

    this.editNoteForm.patchValue({
      date:               dateValue,
      noteType:           noteTypeKey,
      supportingDocument: this.selectedNote.document_name || '',
      notes:              this.selectedNote.notes || ''
    });

    this.editNoteForm.markAsPristine();
    this.editNoteForm.markAsUntouched();
  }
}


updateNote(): void {
  if (this.editNoteForm.invalid) {
    this.editNoteForm.markAllAsTouched();
    this.alertService.error(
      this.lookupToast?.['T0017'] || 'Missing required information. Complete all fields to continue.'
    );
    return;
  }

  const noteId = this.selectedNote?.document_id || this.selectedNote?.id;
  if (!noteId) {
    this.alertService.error('Missing note ID. Cannot update record.');
    return;
  }

  const raw = this.editNoteForm.value;
  const sessionUser = JSON.parse(sessionStorage.getItem('user') || '{}');

  const payload = {
    document_id:         noteId,
    person_id:           this.personId ? Number(this.personId) : null,
    date:                raw.date,
    note_type:           raw.noteType,
    // supporting_document: raw.supportingDocument,
    notes:               raw.notes,
    updated_by:          sessionUser?.id ? Number(sessionUser.id) : null
  };
  this.httpService.patch(`${API_ENDPOINTS.UPDATE_DOCUMENT_NOTES}/${noteId}`, payload).subscribe({
    next: (res: any) => {
      if(res.success === false) {
        this.alertService.error(
          res.message || 'Failed to update note.');
      } else {
        this.alertService.success(
          this.lookupToast?.['T0020'] || 'Updated Successfully.', true
        );
        this.closeEditNoteModal();
        this.refreshCommunicationsData();
      }
    },
    error: (err: any) => {
      this.alertService.error(
        err?.error?.message || err?.message || 'Failed to update note.'
      );
    }
  });
}

// onOpenEditNoteUploadWarning(): void {
//   this.staffDocNoticeModal.open({ contentVariant: 'communication' }).then((confirmed) => {
//     if (confirmed) {
//       this.openEditNoteUploadModal();
//     }
//   });
// }

// openEditNoteUploadModal(): void {
//   this.uploadData = { file: null, fileName: '', type: '' };
//   this.uploadError = null;
//   this.saveEnable = true;
//   this.uploadDocMetaForm.reset();
//   this.isEditNoteUpload = true;
//   this.uploadModalRef = this.modalService.open(this.uploadModel, {
//     size: 'lg',
//     centered: true,
//     backdrop: 'static',
//     keyboard: false,

//   });
// }

openEditNoteDatePicker(event?: Event): void {
  if (event) event.stopPropagation();

  const dobInput = document.getElementById('edit_note_date');
  if (!dobInput) return;

  const rect = dobInput.getBoundingClientRect();
  const dateInput = document.createElement('input') as HTMLInputElement;
  dateInput.type = 'date';
  dateInput.style.position = 'absolute';
  dateInput.style.top  = rect.top + window.scrollY + 5 + 'px';
  dateInput.style.left = rect.left + 'px';
  dateInput.style.width  = '120px';
  dateInput.style.height = '35px';
  dateInput.style.opacity      = '0.01';
  dateInput.style.border       = 'none';
  dateInput.style.zIndex       = '9999';
  dateInput.style.pointerEvents = 'auto';
  dateInput.min = this.currentDate;

  const currentValue = this.editNoteForm.get('date')?.value;
  if (currentValue && currentValue.includes('/')) {
    const parts = currentValue.split('/');
    if (parts.length === 3 && parts[2].length === 4) {
      dateInput.value = `${parts[2]}-${parts[0].padStart(2,'0')}-${parts[1].padStart(2,'0')}`;
    }
  }

  document.body.appendChild(dateInput);

  const cleanup = () => {
    if (document.body.contains(dateInput)) {
      dateInput.removeEventListener('change', changeHandler);
      dateInput.removeEventListener('blur',   blurHandler);
      document.body.removeChild(dateInput);
    }
  };

  const changeHandler = (changeEvent: Event) => {
    const selected = (changeEvent.target as HTMLInputElement).value;
    if (selected) {
      const [year, month, day] = selected.split('-');
      const formatted = `${month}/${day}/${year}`;
      this.editNoteForm.get('date')?.setValue(formatted);
      this.editNoteForm.get('date')?.markAsTouched();
      this.editNoteForm.get('date')?.markAsDirty();
      this.editNoteForm.get('date')?.updateValueAndValidity();
    }
    cleanup();
  };

  const blurHandler = () => setTimeout(cleanup, 100);
  dateInput.addEventListener('change', changeHandler);
  dateInput.addEventListener('blur',   blurHandler);
  dateInput.focus();

  if (typeof (dateInput as any).showPicker === 'function') {
    try { (dateInput as any).showPicker(); } catch { dateInput.click(); }
  } else {
    dateInput.click();
  }
}

private applyTemplateDataToBody(html: string, templateData: any): string {
    if (!html) return html;

    // Parse templateData if it's a JSON string
    let data = templateData;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        console.error('Failed to parse templateData JSON:', e);
        return html;
      }
    }

    if (!data || typeof data !== 'object') return html;

    let result = html;
    
    // Helper to escape regex special characters
    const escapeRegex = (str: string): string => {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };
    
    // Helper to convert camelCase to snake_case
    const camelToSnake = (str: string): string => {
      return str.replace(/([A-Z])/g, '_$1').toLowerCase();
    };
    
    // Helper to convert snake_case to camelCase
    const snakeToCamel = (str: string): string => {
      return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    };
    
    // Helper to convert to lowercase
    const toLower = (str: string): string => str.toLowerCase();
    
    // Build normalized key lookup map
    // Map: normalized_key → original_value
    const keyMap = new Map<string, string>();
    for (const [key, value] of Object.entries(data)) {
      if (value !== null && value !== undefined && typeof value !== 'object') {
        const stringValue = String(value ?? '').trim();
        const normalizedKey = toLower(key); // Store using lowercase as key
        keyMap.set(normalizedKey, stringValue);
      }
    }
    
    console.log('🔑 Template Data Received:', data);
    console.log('🗺️ Key Map Built:', Array.from(keyMap.entries()));
    
    // Find all placeholder patterns in HTML and replace them
    // Pattern: {{$json["key"]}} or {{$json['key']}} or {{key}}
    const placeholderRegex = /{{\s*(?:\$json\[\s*["'])?([^"'\]{}]+)(?:["']\s*\])?\s*}}/gi;
    
    let matchCount = 0;
    result = result.replace(placeholderRegex, (match, fieldName) => {
      matchCount++;
      const fieldNameTrimmed = fieldName.trim();
      console.log(`\n📍 Match ${matchCount}: "${match}"`);
      console.log(`   Extracted fieldName: "${fieldNameTrimmed}"`);
      
      // Try exact match (case-insensitive)
      const lowerFieldName = toLower(fieldNameTrimmed);
      console.log(`   1️⃣ Exact lowercase match: "${lowerFieldName}"`);
      if (keyMap.has(lowerFieldName)) {
        const value = keyMap.get(lowerFieldName);
        console.log(`   ✅ FOUND: "${value}"`);
        return value || match;
      }
      
      // Try converting snake_case to camelCase
      const camelFromSnake = snakeToCamel(fieldNameTrimmed);
      const camelLower = toLower(camelFromSnake);
      console.log(`   2️⃣ Snake→Camel: "${fieldNameTrimmed}" → "${camelFromSnake}" → "${camelLower}"`);
      if (keyMap.has(camelLower)) {
        const value = keyMap.get(camelLower);
        console.log(`   ✅ FOUND: "${value}"`);
        return value || match;
      }
      
      // Try converting camelCase to snake_case
      const snakeFromCamel = camelToSnake(fieldNameTrimmed);
      const snakeLower = toLower(snakeFromCamel);
      console.log(`   3️⃣ Camel→Snake: "${fieldNameTrimmed}" → "${snakeFromCamel}" → "${snakeLower}"`);
      if (keyMap.has(snakeLower)) {
        const value = keyMap.get(snakeLower);
        console.log(`   ✅ FOUND: "${value}"`);
        return value || match;
      }
      
      // No match found, return original placeholder
      console.log(`   ❌ NO MATCH - Returning original: "${match}"`);
      return match;
    });
    
    console.log(`\n✨ Template substitution complete. Total matches: ${matchCount}`);
    
    return result;
  }


}
